<div class="secondary-toolbar-placeholder">&nbsp;</div>

<div
  [ngClass]="{ fixed: fixed$ | async, 'w-full': (fixed$ | async) === false }"
  class="secondary-toolbar z-40 border-t flex items-stretch">
  <div
    class="px-3 sm:px-6 w-full flex items-center flex-wrap gap-2 sm:gap-3 py-1.5"
    [class.container]="isVerticalLayout$ | async">
    @if (showBack) {
      <button
        type="button"
        mat-icon-button
        [attr.aria-label]="backLabel"
        (click)="goBack()">
        <mat-icon svgIcon="mat:arrow_back"></mat-icon>
      </button>
    }
    @if (icon; as ic) {
      <div class="rounded-full bg-primary-100 p-2 shrink-0">
        @if (ic.startsWith('mat:')) {
          <mat-icon class="text-primary-600" [svgIcon]="ic"></mat-icon>
        } @else {
          <mat-icon class="text-primary-600">{{ ic }}</mat-icon>
        }
      </div>
    }

    @if (compact$ | async) {
      <!-- Compact: one row. The trail runs INTO the title — the crumb that
           would repeat it is dropped, so the whole line reads
           "🏠 › Portfolio › Contracts" with the last item as the page title.
           Nothing is lost relative to the stacked layout, 28px are. -->
      <div class="secondary-toolbar-title flex items-center gap-2 min-w-0 flex-1">
        <app-breadcrumbs
          class="hidden md:block leading-none"
          [hideCurrent]="dropLastCrumb"></app-breadcrumbs>
        <h1 class="subheading-2 font-medium m-0 leading-tight truncate">
          {{ displayTitle }}
        </h1>
      </div>
    } @else {
      <!-- Left: title (+ breadcrumbs from sm). Shrinks so projected actions stay
           reachable on a narrow bar. Breadcrumbs hide below sm — the fixed
           toolbar height cannot fit two text rows without vertical overlap.
           flex-1 keeps projected actions (e.g. Fermer) pinned to the right. -->
      <div class="secondary-toolbar-title flex flex-col justify-center gap-0.5 sm:gap-1 min-w-0 flex-1">
        <h1 class="subheading-2 font-medium m-0 leading-tight truncate">
          {{ displayTitle }}
        </h1>
        @if (subtitle) {
          <p class="caption text-hint m-0 leading-none truncate">{{ subtitle }}</p>
        } @else {
          <app-breadcrumbs class="hidden sm:block leading-none"></app-breadcrumbs>
        }
        <!-- Rich subtitle (chips, links…) — projected when a plain string isn't
             enough. Mirrors `PageHeaderComponent`'s `[page-subtitle]` slot. -->
        <ng-content select="[page-subtitle]"></ng-content>
      </div>
    }

    <ng-content></ng-content>
  </div>
</div>
